import { Variant } from 'shared/types/product';

export function getDiscount(item: Variant) {
  if (!item?.discountedPrice?.centAmount || !item?.price?.centAmount) {
    return { hasDiscount: false, discountPercentage: 0 };
  }
  const discountedPrice = item?.discountedPrice;

  const hasDiscount = item.discountedPrice.centAmount < item.price.centAmount;

  const discountPercentage = hasDiscount
    ? ((item.price.centAmount - item.discountedPrice.centAmount) / item.price.centAmount) * 100
    : 0;

  return {
    hasDiscount,
    discountedPrice,
    discountPercentage,
  };
}
